<template>
  <div>
    <InitialQuestion
      :save-data="saveData"
      :next-question="nextQuestion"
      :disabled-criteria="disabledCriteria"
    >
      <template v-slot:form>
        <h5 class="text-center">
          ¿Qué áreas te interesan?
        </h5>
        <hr>
        <!-- Pregunta de Áreas de interés<br> -->
        <div class="areas__selected">
          <span
            v-for="(area, index) in chosen_areas"
            :key="index"
            class="areas__tag areas__tag--selected"
            @click="removeArea(area)"
          >
            {{ area.long_name }} <fa-icon icon="times-circle" />
          </span>
        </div>
        <hr>
        <div>
          <a
            v-for="(area, index) in available_areas"
            :key="index"
            class="areas__tag"
            @click="addArea(area)"
          >
            <fa-icon icon="plus-circle" /> {{ area.long_name }}
          </a>
        </div>
        <br>
      </template>
    </InitialQuestion>
  </div>
</template>

<script>
// @ is an alias to /src
import InitialQuestion from '@/components/InitialQuestion.vue';
import { careersService, studentsService } from '../../_services';

export default {
    name: 'Areas',
    components: {
        InitialQuestion,
    },
    data() {
        return {
            chosen_areas: [],
            available_areas: [],
        };
    },
    mounted() {
        this.$nextTick(function () {
            this.$store.commit('authentication/checkedArea');
            this.list_areas();
        });
    },
    methods: {
        disabledCriteria() {
            return this.chosen_areas.length === 0;
        },
        async saveData() {
            studentsService.patchStudent(
                this.$store.getters['authentication/student_uuid'],
                { areas: this.chosen_areas },
            );
        },
        nextQuestion() {
            this.$store.commit('authentication/answeredArea');
            this.$nextTick().then(() => {
                this.$router.push({ name: 'ana' });
            });
        },
        list_areas() {
            careersService.listAreas(
                this.$store.getters['authentication/student_uuid'],
            ).then((response) => {
                this.available_areas = response.data;
            });
        },
        addArea(chosenArea) {
            this.chosen_areas.push(chosenArea);
            this.available_areas = this.available_areas.filter(
                value => value.name !== chosenArea.name,
            );
        },
        removeArea(areaToRemove) {
            this.chosen_areas = this.chosen_areas.filter(value => value.name !== areaToRemove.name);
            this.available_areas.push(areaToRemove);
        },
    },
};
</script>
<style lang="scss">
.areas {
  &__selected {
    min-height: 42px;
  }

  &__tag{
    border: 1px solid #666 !important;
    color: #666 !important;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover{
      // background-color: #eee;
      background-color: #54A9FC !important;
      border-color: #54A9FC !important;
      color: white !important;
    }

    &--selected{
      background-color: #54A9FC;
      border-color: #54A9FC !important;
      color: white !important;
    }
  }
}
</style>
